/** Record lists share Punch's hierarchy. Keep headings distinct from row
 * titles, names, secondary copy and compact numeric metadata. */
export const LIST_TYPE = {
  head: 11.5,
  title: 17.25,
  titleWeight: 500,
  name: 15.52,
  sub: 13.8,
  priority: 14.95,
  mono: 12.65,
} as const;
